import TaskGenerator from "@/model/TaskGenerator";

export default class DeviceTaskGenerator extends TaskGenerator<DeviceTaskGenerator> {
}
